// extracted by mini-css-extract-plugin
module.exports = {"file-icon":"file-icon__file-icon___2sp_M"};